module.exports = __webpack_public_path__ + "img/T1B_rc_33.d249bf58.png";